import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { UserModel } from './models/user-model';
import { AuthService } from './services/auth/auth.service';
import { UtilService } from './services/util/util.service';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterContentChecked {
  user!: UserModel;
  isLoading: Subject<boolean>;
  isLoggedIn: boolean = false;

  constructor(public authService: AuthService, private utilService: UtilService,
    private changeDetector: ChangeDetectorRef, private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: Document, private renderer: Renderer2) {

    this.isLoading = this.utilService.isLoading;

    this.utilService.brandSelectedEvent.subscribe(() => {
      let favIcon: HTMLLinkElement | null = document.querySelector("link[rel='icon']");

      let brand = sessionStorage.getItem('brand');
      if (brand == 'AU') {
        favIcon && (favIcon.href = './assets/images/favicon_audi.ico');
        // add the them css to the body tag as the pop-up layers are rendered outside app-root and the css override does not apply
        this.renderer.removeClass(this.document.body, 'theme-vw');
        this.renderer.addClass(this.document.body, 'theme-audi');
      } else {
        favIcon && (favIcon.href = './assets/images/favicon_vw.ico');
        this.renderer.addClass(this.document.body, 'theme-vw');
        this.renderer.removeClass(this.document.body, 'theme-audi');
      }
    });
  }

  ngOnInit(): void {
    this.authService.initiateAuth();
    // added for security reasons to avoid exposing the Angular version in the app-root node
    this.elementRef.nativeElement.removeAttribute("ng-version");

    this.authService.loginEvent.subscribe((isLoggedIn) => {
      this.isLoggedIn = isLoggedIn;
      if (isLoggedIn) {
        this.authService.getUser().then((user) => {
          this.user = user;
        });
      }
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
}